/**
 * Adds `script` to the page. Resolves true on load, false on error. Never rejects.
 * `onSettled` runs inside the load/error handler, before the promise resolves.
 */
export function loadScript(script: HTMLScriptElement, onSettled?: (loaded: boolean) => void): Promise<boolean> {
  const loaded = new Promise<boolean>((resolve) => {
    const settle = (ok: boolean) => {
      onSettled?.(ok);
      resolve(ok);
    };
    script.onload = () => settle(true);
    script.onerror = () => settle(false);
  });
  (document.body ?? document.head).appendChild(script);
  return loaded;
}
